import { FormatLetterSpacingIcon } from './FormatLetterSpacingIcon';

/**
 * author: Michael Irigoyen
 * id 868506A4-50DB-4C9C-9CEA-278969298EF4
 * name format-letter-spacing
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-letter-spacing.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatKerningIcon = FormatLetterSpacingIcon;
export default FormatKerningIcon